/* global wp */
import Notice from './elements/notice'

const { __ } = wp.i18n

const Dashboard = () => {
	return (
		<main className="sui-wrap">
			<Notice type="success">
				<p>{__('Successfully connected to the Hub.', 'wpmudev')}</p>
			</Notice>
		</main>
	)
}

export default Dashboard
